// Permisos de ruta: única implementación del proyecto. La consumen el guard,
// los dos drawers y el launcher.
//
// Este módulo NO importa el árbol de rutas a propósito: así `routes.js` puede
// importarlo para sus redirects sin crear un ciclo de imports.
import { isLockedToPortal } from '@/util/cad-incident-utils'

// Recorre la cadena `matched` completa, no solo el meta de la hoja.
// Vue Router 3 define `meta: (record && record.meta) || {}` — el meta del
// padre NO se fusiona —, así que leer `to.meta` deja los gates de grupo sin
// aplicar. `filterMenu` del AppDrawer sí los aplicaba: menú y guard operaban
// con reglas distintas.
export function canAccess(route, user) {
  if (!route) return false
  if (!user) return false
  if (user.administrator) return true
  // Un usuario sin `attributes` (sesión a medio limpiar, respuesta parcial del
  // backend) haría reventar los ~20 closures `(u) => !!u.attributes.x`.
  const u = user.attributes ? user : { ...user, attributes: {} }
  const chain = (route.matched && route.matched.length) ? route.matched : [route]
  return chain.every((record) => {
    const meta = (record && record.meta) || {}
    if (meta.admin) return false
    if (!meta.validate) return true
    return !!meta.validate(u)
  })
}

// Primer registro accesible, en orden de declaración de `routes.js`.
export function firstAccessible(records, user) {
  return (records || []).find((r) => canAccess(r, user)) || null
}

// Busca un registro por path a cualquier profundidad del árbol.
function findRecordByPath(records, path) {
  return (records || []).reduce((hit, r) => {
    if (hit) return hit
    if (r && r.path === path) return r
    return r && r.children ? findRecordByPath(r.children, path) : null
  }, null)
}

// Primer hijo accesible de una sección, leyendo sus hijos REALES del árbol.
// Los redirects de sección llevaban esa lista copiada a mano con sus gates
// duplicados; la copia de `/administracion` ya se había desincronizado.
// `routes.js` puede llamar a esto sin ciclo porque este módulo no lo importa.
export function firstAccessibleChild(records, sectionPath, user) {
  const section = findRecordByPath(records, sectionPath)
  return firstAccessible(section && section.children, user)
}

// Destino de aterrizaje por perfil. Lo usan Login, el redirect de `/` y las
// ramas de denegación del guard, para que un operador no atraviese dos guards
// y dos GET /session antes de caer rebotado en el mapa.
export function resolveLandingRoute(user) {
  if (isLockedToPortal(user)) return { name: 'incident-portal' }
  if (user && user.administrator) return { name: 'home' }
  return { name: 'map' }
}
